import { render, staticRenderFns } from "./AStaffDetailItemOutApply.vue?vue&type=template&id=6b000b3c&scoped=true"
import script from "./AStaffDetailItemOutApply.vue?vue&type=script&lang=js"
export * from "./AStaffDetailItemOutApply.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailItemOutApply.vue?vue&type=style&index=0&id=6b000b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b000b3c",
  null
  
)

export default component.exports